export default "__VITE_ASSET__44240d9d__"